
export class HeaderButton {
	public text: string;
	public class?: string;
	public callback?: Function;
	public children?: Array<HeaderButton>;
	public disabled?: boolean;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}